import React from "react";
import styled from "styled-components";
import Select from "components/common/Select";
import { defaultCompare } from "logic/DefaultCompare";
const Container = styled.div`
  flex: 1;
  grid-area: streams;
`;
const StreamCategoryFilter = ({ disabled = false, value = [], streamCategories, onChange }) => {
  const selectedCategories = value.join(",");
  const placeholder = "Select stream categories the search should include.";
  const options = streamCategories.sort(({ key: key1 }, { key: key2 }) => defaultCompare(key1, key2));
  const handleChange = (selected) => {
    onChange(selected === "" ? [] : selected.split(","));
  };
  if (!streamCategories || streamCategories.length < 1) return null;
  return /* @__PURE__ */ React.createElement(Container, { "data-testid": "stream-category-filter", title: placeholder }, /* @__PURE__ */ React.createElement(
    Select,
    {
      placeholder,
      disabled,
      displayKey: "key",
      inputId: "stream-categories-filter",
      onChange: handleChange,
      options,
      multi: true,
      value: selectedCategories
    }
  ));
};
export default StreamCategoryFilter;
